import {
  getErrors,
  loading,
  setBankAccounts,
  setBanks,
  setPaginator,
  setPendingWallet,
  setSettledWallet,
  setTransactions,
  setWithdraw,
  setWithdrawHistories,
} from '@/reducers/financial';
import { headers } from '@/services/headers';
import { ThunkAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../store';

export const GetTransactions =
  (
    slug?: string,
    query?: string,
    page = 1
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/revenues?filter[search]=` +
          query +
          '&page=' +
          page,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setTransactions(response.data.data));
        dispatch(setPaginator(response.data.meta));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const GetWithdraws =
  (
    slug?: string,
    query?: string,
    page = 1
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/withdraws?filter[search]=` +
          query +
          '&page=' +
          page,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setWithdrawHistories(response.data.data));
        dispatch(setPaginator(response.data.meta));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const StoreWithdraw =
  (slug?: string, formData?: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .post(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/withdraws`,
        formData,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setWithdraw(response.data.data));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const ShowPendingBalance =
  (slug?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/balances/pending`,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setPendingWallet(response.data.data));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const ShowSettledBalance =
  (slug?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/balances/settled`,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setSettledWallet(response.data.data));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const GetBanks =
  (slug?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .get(
        process.env.REACT_APP_BASE_URL + `/org/events/${slug}/financial/banks`,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setBanks(response.data.data));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const GetBankAccounts =
  (slug?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .get(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/bank-accounts`,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setBankAccounts(response.data.data));
        dispatch(setPaginator(response.data.meta));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const StoreBankAccount =
  (slug?: string, formData?: any): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .post(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/bank-accounts`,
        formData,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setBankAccounts([response.data.data]));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };

export const UpdateBankAccount =
  (
    slug?: string,
    bankAccountId?: string,
    formData?: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .patch(
        process.env.REACT_APP_BASE_URL +
          `/org/events/${slug}/financial/bank-accounts/${bankAccountId}`,
        formData,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setBankAccounts([response.data.data]));

        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };
